import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "Localização não encontrada", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Por favor, selecione uma cidade e um bairro para poder consultar os estabelecimentos. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2
  ]))
}